import React, { useEffect } from 'react';
import './Home.css';
import Case from '../Case/Case';
import Companies from '../Companies/Companies';
import Footer from '../Footer/Footer';
import Hero from '../Hero/Hero';
import Portfolio from '../Portfolio/Portfolio';
import Skillset from '../Skillset/Skillset';
import Started from '../Started/Started';
import "aos/dist/aos.css";
import Aos from "aos";
import Scrollbar from 'smooth-scrollbar';
import MessengerCustomerChat from 'react-messenger-customer-chat';

import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Fab from '@material-ui/core/Fab';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Zoom from '@material-ui/core/Zoom';


const Home = (props) => {
    useEffect(() => {
        // Scrollbar.init(document.querySelector('#home'));
        Aos.init({ duration: 1000 })
    }, [])
    const useStyles = makeStyles((theme) => ({
        root: {
          position: 'fixed',
          bottom: theme.spacing(2),
          right: theme.spacing(2),
        },
      }));
      
      function ScrollTop(props) {
        const { children, window } = props;
        const classes = useStyles();
        // Note that you normally won't need to set the window ref as useScrollTrigger
        // will default to window.
        // This is only being set here because the demo is in an iframe.
        const trigger = useScrollTrigger({
          target: window ? window() : undefined,
          disableHysteresis: true,
          threshold: 100,
        });
      
        const handleClick = (event) => {
          const anchor = (event.target.ownerDocument || document).querySelector('#back-to-top-anchor');
      
          if (anchor) {
            anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        };
      
        return (
          <Zoom in={trigger}>
            <div onClick={handleClick} role="presentation" className={classes.root}>
              {children}
            </div>
          </Zoom>
        );
      }
      
      ScrollTop.propTypes = {
        children: PropTypes.element.isRequired,
        /**
         * Injected by the documentation to work in an iframe.
         * You won't need it on your project.
         */
        window: PropTypes.func,
      };
    return (
        <div id="home" className="home-root">
            
            <Toolbar id="back-to-top-anchor" />
      
            <Hero/>
            <Companies/>
            <Skillset/>
            <Portfolio/>
            <Started/>
            <Case/>
            <Footer/>
            <div>
            <MessengerCustomerChat
                pageId="115681463582509"
                appId="3497133206990167"
                shouldShowDialog="true"
                // htmlRef="<REF_STRING>"
            />
            </div>
    
            <div className="mb-4">
            <ScrollTop {...props}>
                <Fab color="secondary" size="small" aria-label="scroll back to top">
                <KeyboardArrowUpIcon />
                </Fab>
            </ScrollTop>
            </div>
        </div>
    );
};

export default Home;